import { render, staticRenderFns } from "./ArticleViewAll.vue?vue&type=template&id=4816dfc6&scoped=true&lang=pug&"
import script from "./ArticleViewAll.vue?vue&type=script&lang=js&"
export * from "./ArticleViewAll.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewAll.vue?vue&type=style&index=0&id=4816dfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4816dfc6",
  null
  
)

export default component.exports